(()=>{
if(window.npvLoaded)return;
window.npvLoaded=true;
document.addEventListener('click',e=>{
const open=e.target.closest('[data-npv-open]');
if(open){
const d=document.getElementById(open.getAttribute('data-npv-open'));
if(d&&typeof d.showModal==='function'){
e.preventDefault();
d.querySelectorAll('iframe[data-npv-src]').forEach(f=>{if(f.getAttribute('src')!==f.dataset.npvSrc)f.setAttribute('src',f.dataset.npvSrc);});
d.showModal();
const v=d.querySelector('video');
if(v){const p=v.play();if(p&&p.catch)p.catch(()=>{});}
}
return;
}
const close=e.target.closest('[data-npv-close]');
if(close){const d=close.closest('dialog');if(d)d.close();return;}
if(e.target.matches&&e.target.matches('dialog.npv-modal'))e.target.close();
});
document.addEventListener('close',e=>{
const d=e.target;
if(!d.matches||!d.matches('dialog.npv-modal'))return;
d.querySelectorAll('video').forEach(v=>v.pause());
d.querySelectorAll('iframe').forEach(f=>{if(f.dataset.npvSrc)f.removeAttribute('src');else{const s=f.src;f.src=s;}});
},true);
const viewers=root=>root.querySelectorAll('[data-npv-viewer]').forEach(v=>{
if(v.dataset.npvReady)return;
v.dataset.npvReady='1';
const slides=[...v.querySelectorAll('[data-npv-slide]')];
const caps=[...v.querySelectorAll('[data-npv-cap]')];
const dots=[...v.querySelectorAll('[data-npv-dot]')];
const stage=v.querySelector('[data-npv-stage]')||v;
const n=slides.length;
if(n<2)return;
let i=0,timer=null,touched=false,x0=null;
const go=(k,dir)=>{
const old=i;
i=(k+n)%n;
if(old===i)return;
const fwd=dir===undefined?true:dir>0;
slides.forEach((s,j)=>{
s.classList.toggle('is-active',j===i);
if(j===old)s.classList.toggle('is-left',fwd);
if(j===i)s.classList.remove('is-left');
s.setAttribute('aria-hidden',j===i?'false':'true');
});
caps.forEach((c,j)=>{c.classList.toggle('is-active',j===i);c.querySelectorAll('a').forEach(a=>a.tabIndex=j===i?0:-1);});
dots.forEach((d,j)=>{d.classList.toggle('is-active',j===i);d.setAttribute('aria-pressed',j===i?'true':'false');});
};
const stop=()=>{if(timer){clearInterval(timer);timer=null;}};
const play=()=>{
if(touched||v.dataset.auto!=='1'||(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches))return;
stop();
timer=setInterval(()=>go(i+1,1),Math.max(2000,+v.dataset.speed||4000));
};
const manual=(k,dir)=>{touched=true;stop();go(k,dir);};
const prev=v.querySelector('[data-npv-prev]');
const next=v.querySelector('[data-npv-next]');
if(prev)prev.addEventListener('click',()=>manual(i-1,-1));
if(next)next.addEventListener('click',()=>manual(i+1,1));
dots.forEach((d,j)=>d.addEventListener('click',()=>manual(j,j>=i?1:-1)));
v.addEventListener('keydown',e=>{
if(e.key==='ArrowRight'){e.preventDefault();manual(i+1,1);}
if(e.key==='ArrowLeft'){e.preventDefault();manual(i-1,-1);}
});
stage.addEventListener('pointerdown',e=>{if(e.target.closest('button'))return;x0=e.clientX;});
stage.addEventListener('pointerup',e=>{
if(x0===null)return;
const dx=e.clientX-x0;
x0=null;
if(Math.abs(dx)>40)manual(dx<0?i+1:i-1,dx<0?1:-1);
});
stage.addEventListener('pointercancel',()=>{x0=null;});
stage.addEventListener('pointerleave',()=>{x0=null;});
v.addEventListener('mouseenter',stop);
v.addEventListener('mouseleave',play);
v.addEventListener('focusin',stop);
document.addEventListener('shopify:block:select',e=>{const k=slides.findIndex(s=>s.contains(e.target)||s===e.target);if(k>-1&&v.contains(e.target))manual(k,1);});
if('IntersectionObserver' in window){
v.npvObserver=new IntersectionObserver(([en])=>{if(en.isIntersecting)play();else stop();},{threshold:.35});
v.npvObserver.observe(v);
}else play();
});
const sticky=root=>root.querySelectorAll('[data-npv-sticky]').forEach(bar=>{
if(bar.dataset.npvReady)return;
bar.dataset.npvReady='1';
const target=document.querySelector('[data-npv-buy]');
if(!target)return;
const apply=show=>{
if(bar.classList.contains('is-visible')===show)return;
bar.classList.toggle('is-visible',show);
document.body.classList.toggle('npv-sticky-on',show);
};
const mob=window.matchMedia('(max-width: 749px)');
const off=r=>r.bottom<0||(mob.matches&&r.top>window.innerHeight);
const check=()=>apply(off(target.getBoundingClientRect()));
let ticking=false;
window.addEventListener('scroll',()=>{if(ticking)return;ticking=true;requestAnimationFrame(()=>{ticking=false;check();});},{passive:true});
window.addEventListener('resize',check,{passive:true});
if('IntersectionObserver' in window){
bar.npvObserver=new IntersectionObserver(([en])=>apply(!en.isIntersecting&&off(en.boundingClientRect)),{threshold:0});
bar.npvObserver.observe(target);
}
check();
});
const init=r=>{viewers(r);sticky(r);};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
document.addEventListener('shopify:section:load',e=>init(e.target));
})();
